import * as React from 'react';
import { Grid, Paper, Tabs, Tab, Box, Typography } from '@mui/material';
import ClientsView from '../../features/ama/components/clients-view';
import SnapshotsView from '../../features/ama/components/snapshots-view';
// import SchemaView from '../../features/ama/components/schema-view';
import SchemaView from '../schema-view';
import HelpView from '../../features/ama/components/help-view';
import { Link } from 'react-router-dom';

const SILVER_DB = 'ama_common_silver_db_dev';
const SILVER_TABLE = 'ama_silver_core';

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: number;
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <Box
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      sx={{ height: '100%'}}
      {...other}>

      {value === index && (
        <Box sx={{ p: 3, height: '100%', flexGrow: 1}}>
          {children}
        </Box>
      )}
    </Box>
  );
}

export default function AmaView() {

  const [value, setValue] = React.useState(0);
  const routes = ["/ama/snapshots", "/ama/clients", "/ama/schema", "/ama/help"];
  
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    let currentTab = routes.indexOf(location.pathname);
    if (currentTab < 0) 
    {
      currentTab = 0;
      window.history.replaceState(null, '', '/ama/snapshots');
    }
    setValue(currentTab);
  }, [value]);

  // const handleChangeIndex = (index: number) => {
  //   setValue(index);
  // };

  return (
    <Grid item xs={12} sx={{ position: 'relative', height: '100%' }}>
      <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Typography component="h2" variant="h6" color="primary" gutterBottom>
          Aid Matriculation Analysis: ETL Pipeline
        </Typography>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="AMA tabbed features">
            <Tab label="Snapshots" component={Link} to={routes[0]} {...a11yProps(0)} />
            <Tab label="Clients"  component={Link} to={routes[1]} {...a11yProps(1)} />              
            <Tab label="Schema" component={Link} to={`${routes[2]}?db=${SILVER_DB}&table=${SILVER_TABLE}`} {...a11yProps(2)} />
            <Tab label="Help" component={Link} to={routes[3]} {...a11yProps(3)} />
          </Tabs>
        </Box>        
        <CustomTabPanel value={value} index={0}>            
          <SnapshotsView/>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <ClientsView/>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <SchemaView isWrapperVisible={false}/>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          <HelpView/>
        </CustomTabPanel>
      </Paper>
    </Grid>
  );
}





{/* <AppBar position="static">
<Tabs
  value={value}
  onChange={handleChange}
  indicatorColor="secondary"
  textColor="inherit"
  variant="fullWidth"
  aria-label="full width tabs example"
>
  <Tab label="Item One" {...a11yProps(0)} />
  <Tab label="Item Two" {...a11yProps(1)} />
  <Tab label="Item Three" {...a11yProps(2)} />
</Tabs>
</AppBar>

<TabPanel value={value} index={0} dir={theme.direction}>
  Item One
</TabPanel>
<TabPanel value={value} index={1} dir={theme.direction}>
  Item Two
</TabPanel>
<TabPanel value={value} index={2} dir={theme.direction}>
  Item Three
</TabPanel> */}

// function a11yProps(index: number) {
//   return {
//     id: `full-width-tab-${index}`,
//     'aria-controls': `full-width-tabpanel-${index}`,
//   };
// }

// function TabPanel(props: TabPanelProps) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`full-width-tabpanel-${index}`}
//       aria-labelledby={`full-width-tab-${index}`}
//       {...other}
//     >
//       {value === index && (
//         <Box sx={{ p: 3 }}>
//           <Typography>{children}</Typography>
//         </Box>
//       )}
//     </div>
//   );
// }